<template>
  <SupplierNameColumn v-if="link" :row="link" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import SupplierNameColumn from '@/components/GraphqlDataTable/columns/SupplierClient/SupplierNameColumn.vue'

const OwnerStaffingAgencyColumn = graphql(`
  fragment OwnerStaffingAgencyColumn on Owner {
    id
    owned {
      __typename
      ... on SupplierClient {
        id
        ...SupplierNameColumn
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof OwnerStaffingAgencyColumn>
  rowIndex?: number
}>()

const link = computed(() => {
  const { owned } = useFragment(OwnerStaffingAgencyColumn, props.row)

  return owned?.__typename === 'SupplierClient' ? owned : null
})
</script>
